import React from 'react';
import { useIntl } from 'react-intl';
import { Panel, Circle, Typography } from '@icecreamsocial/components';
import { GiftCardIcon } from '../SupportedIcons';

export const OfferHint = ({ conversionGoal, ...rest }) => {
	/**
	 * init hooks
	 */
	const intl = useIntl();

	/**
	 * localization keys
	 */
	const OFFER_HINT = intl.formatMessage(
		{
			id: 'offer.hint',
			defaultMessage:
				"When {conversionGoal, plural,  one {# friend makes a purchase} two {# friends make purchases} few {# friends make purchases} many {# friends make purchases} other {# friends make purchases}}, you'll receive your reward!",
			description:
				'Tells the user how many of their friends need to make a purchase before they are eligible for a reward.  Please only translate the text that is highlighted in blue.  Make sure to include the pluralization in the translation.  If this number is 0, this message will not be shown at all',
		},
		{
			conversionGoal,
		}
	);
	return (
		<Panel
			backgroundColor='ambientLight'
			marginBottom='xlg'
			border='none'
			{...rest}
		>
			<Panel.Body display='flex' alignItems='center' style={{ gap: '8px' }}>
				<Circle backgroundColor='accent' flexShrink='0'>
					<GiftCardIcon />
				</Circle>
				<Typography.P>{OFFER_HINT}</Typography.P>
			</Panel.Body>
		</Panel>
	);
};
